import { Box, Typography } from "@mui/material";
import capitalize from "lodash/capitalize";

import { useInsightsContext } from "../context";
import InsightThreeDotMenu from "./InsightThreeDotMenu";

export const InsightStatus: React.FC = () => {
  const { selectedInsight, setSelectedInsight } = useInsightsContext();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography
          variant="subtitle2"
          sx={{
            color: "text.secondary",
          }}
        >
          Status
        </Typography>
        <Typography variant="h3" sx={{ mb: 1 }}>
          {capitalize(selectedInsight?.userStatusChanges?.status ?? "actionable")}
        </Typography>
      </Box>
      <InsightThreeDotMenu selectedInsight={selectedInsight} updateInsight={setSelectedInsight} />
    </Box>
  );
};
